<template>
    <div class="help-create">
        <data-form title="Add Help Message"
                   tag="help-create"
                   save-button-label="Submit"
                   :field-model="help"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   cancelRoute="/help/list"
                   submit-success-message="help message created"
                   submit-error-message="Error creating help message">
        </data-form>
    </div>
</template>

<script>

import Vue from 'vue'
import Help from '@/models/Help'

export default Vue.extend({
    name: 'HelpCreate',
    data () {
        return {
            help: Help,
            fieldGroups: [
                ['tag', 'content'],
            ],
        }
    },
    methods: {
        loadModelInstance () {
            return this.$route.query.tag ? { tag: this.$route.query.tag } : {}
        },
        onSubmit (modelInstance) {
            return this.$api.createItem(this, 'help', modelInstance)
                .then((response) => {
                    if (response.body.id) {
                        this.$router.push(`/help/view/${response.body.id}`)
                    }
                })
        }
    },
})

</script>
